var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          ref: "dataForm",
          attrs: {
            model: _vm.childData,
            rules: _vm.rules,
            "label-position": "right",
            "label-width": "120px"
          }
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "投诉人" } },
                    [
                      _c("el-input", {
                        staticClass: "form-item-width",
                        attrs: { disabled: "", maxlength: "20" },
                        model: {
                          value: _vm.userName,
                          callback: function($$v) {
                            _vm.userName = $$v
                          },
                          expression: "userName"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "投诉人电话" } },
                    [
                      _c("el-input", {
                        staticClass: "form-item-width",
                        attrs: { disabled: "", maxlength: "20" },
                        model: {
                          value: _vm.complainantsPhone,
                          callback: function($$v) {
                            _vm.complainantsPhone = $$v
                          },
                          expression: "complainantsPhone"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "投诉来源" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "285px" },
                          attrs: {
                            clearable: "",
                            placeholder: "请选择投诉来源"
                          },
                          model: {
                            value: _vm.childData.complaintsSource,
                            callback: function($$v) {
                              _vm.$set(_vm.childData, "complaintsSource", $$v)
                            },
                            expression: "childData.complaintsSource"
                          }
                        },
                        _vm._l(_vm.sourceOption, function(item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.name, value: item.value }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: "预约处理时间", prop: "appointmentTime" }
                    },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "285px" },
                        attrs: {
                          format: "yyyy 年 MM 月 dd 日",
                          "value-format": "yyyy-MM-dd",
                          type: "date",
                          placeholder: "选择预约处理时间"
                        },
                        model: {
                          value: _vm.childData.appointmentTime,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "appointmentTime", $$v)
                          },
                          expression: "childData.appointmentTime"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "联系人", prop: "contact" } },
                    [
                      _c("el-input", {
                        staticClass: "form-item-width",
                        attrs: { maxlength: "10" },
                        model: {
                          value: _vm.childData.contact,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "contact", $$v)
                          },
                          expression: "childData.contact"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "联系人电话", prop: "phone" } },
                    [
                      _c("el-input", {
                        staticClass: "form-item-width",
                        attrs: { maxlength: "11" },
                        model: {
                          value: _vm.childData.phone,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "phone", $$v)
                          },
                          expression: "childData.phone"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "问题发生地", prop: "eventalSite" } },
                    [
                      _c("el-input", {
                        staticClass: "form-item-width",
                        attrs: { maxlength: "20" },
                        model: {
                          value: _vm.childData.eventalSite,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "eventalSite", $$v)
                          },
                          expression: "childData.eventalSite"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "紧急情况", prop: "situationType" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "285px" },
                          attrs: {
                            clearable: "",
                            placeholder: "请选择紧急情况"
                          },
                          model: {
                            value: _vm.childData.situationType,
                            callback: function($$v) {
                              _vm.$set(_vm.childData, "situationType", $$v)
                            },
                            expression: "childData.situationType"
                          }
                        },
                        _vm._l(_vm.situationOption, function(item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.name, value: item.value }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "投诉地址", prop: "complaintAddress" } },
                    [
                      _c("el-input", {
                        staticClass: "form-item-width",
                        attrs: { maxlength: "20" },
                        model: {
                          value: _vm.childData.complaintAddress,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "complaintAddress", $$v)
                          },
                          expression: "childData.complaintAddress"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "投诉内容", prop: "complaintContent" } },
                    [
                      _c("el-input", {
                        staticClass: "form-item-width",
                        attrs: {
                          type: "textarea",
                          autosize: { minRows: 2, maxRows: 2 },
                          maxlength: "200"
                        },
                        model: {
                          value: _vm.childData.complaintContent,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "complaintContent", $$v)
                          },
                          expression: "childData.complaintContent"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "图片" } },
                [
                  _c(
                    "el-upload",
                    {
                      ref: "upload",
                      attrs: {
                        name: "files",
                        "list-type": "picture-card",
                        "on-success": _vm.handleSuccess,
                        action: _vm.uploadUrl,
                        "on-preview": _vm.handlePreview,
                        "on-remove": _vm.handleRemove,
                        "before-remove": _vm.beforeRemove,
                        "before-upload": _vm.beforeUpload,
                        limit: 5,
                        "on-exceed": _vm.handleExceed,
                        "file-list": _vm.files
                      }
                    },
                    [_c("i", { staticClass: "el-icon-plus" })]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogVisible,
            "append-to-body": true,
            title: "预览"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          _c("img", {
            attrs: { width: "100%", src: _vm.dialogImageUrl, alt: "" }
          })
        ]
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c("el-button", { on: { click: _vm.handCancle } }, [
            _vm._v(_vm._s(_vm.$t("button.cancel")))
          ]),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handCreate } },
            [_vm._v(_vm._s(_vm.$t("button.confirm")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }